export interface Message {
    id: string;
    icon?: string;
    image?: string;
    title?: string;
    description?: string;
    time: string;
    link?: string;
    useRouter?: boolean;
    read: boolean;
    // Real-time notification fields
    source_type?: 'system' | 'admin' | 'event';
    event_type?: string;
    entity_type?: string;
    entity_id?: string;
    is_persistent?: boolean;
    timeout_ms?: number;
    severity?: 'info' | 'success' | 'warning' | 'error';
}

export enum ToastPriority {
    ADMIN_PERSISTENT = 0,
    ADMIN_TIMED = 1,
    EVENT = 2,
}

export interface ActiveToast {
    message: Message;
    priority: ToastPriority;
    timerId?: ReturnType<typeof setTimeout>;
    createdAt: number;
}
